<ion-header class="header --w-back-button">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-list class="breadcrumb">
        <ion-item
          *ngFor="let breadcrumb of breadcrumbs"
          class="breadcrumb__item"
          detail="false"
          routerDirection="back"
          [routerLink]="[breadcrumb.link]"
        >
          <span [innerHTML]="breadcrumb.name"></span> <span class="breadcrumb__item__dash">/</span>
        </ion-item>
      </ion-list>
      <ion-back-button [defaultHref]="routes.home" text="" icon="arrow-back-outline"></ion-back-button>
    </ion-buttons>
    <ion-title class="--logo">
      <a class="header__logo" [routerLink]="['/']">
        <app-logo></app-logo>
      </a>
      <span>Veranstaltungen</span>
    </ion-title>
    <ion-buttons slot="end">
      <ion-avatar class="header__avatar" [routerLink]="['..', routes.settings]">
        <img class="header__avatar__image" src="/assets/avatar/anna.svg" [alt]="(user$ | async)?.firstName" />
      </ion-avatar>
      <ion-menu-button class="header__burger" icon="menu-outline" autoHide="false"></ion-menu-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="events">
  <div class="white-wrapper">
    <div class="events__header" [formGroup]="form">
      <ion-item class="events__header__search">
        <ion-input formControlName="search" placeholder="Suche"></ion-input>
      </ion-item>

      <ion-item>
        <ion-select
          formControlName="module"
          cancelText="Abbrechen"
          okText="ok"
          placeholder="Modul"
          (ionChange)="handleModuleSelectorChanged($event)"
        >
          <ion-select-option [value]="undefined">Alle</ion-select-option>
          <ion-select-option value="community">Community</ion-select-option>
          <ion-select-option value="willkommen">Willkommen</ion-select-option>
          <ion-select-option value="finanzen">Finanzen</ion-select-option>
          <ion-select-option value="marketing">Marketing</ion-select-option>
          <ion-select-option value="mitarbeiter">Mitarbeiter</ion-select-option>
          <ion-select-option value="organisation">Organisation</ion-select-option>
          <ion-select-option value="kundenbegeistern">Kunden begeistern</ion-select-option>
        </ion-select>
      </ion-item>
    </div>

    <ion-list class="events__list">
      <ng-container *ngFor="let event of events$ | async">
        <ion-item
          *ngIf="event | filterEvents:form.value.search:form.value.module:(event.contentId | toEventContent | async)"
          class="events__list__item"
          detail="false"
          (click)="handleEventClick(event)"
        >
          <div class="events__list__item__wrapper">
            <ion-img
              [src]="(event.contentId | toEventContent | async)?.imageUrl || 'assets/icon/apple-touch-icon.png'"
              alt=""
              class="events__list__item__avatar"
            ></ion-img>
            <div class="events__list__item__detail">
              <span class="events__list__item__detail__name" [innerHTML]="(event.contentId | toEventContent | async)?.title"></span>
              <span
                class="events__list__item__detail__date"
                [innerHTML]="(event?.recurrence ? (event.recurrence | rruleNextExecution) : (event.date)) | date:'dd. MMMM YYYY HH:mm'"
              ></span>
              <span
                class="events__list__item__detail__module"
                [innerHTML]="(event.contentId | toEventContent | async)?.learningModules | mapModules"
              ></span>
              <app-event-availability
                *ngIf="(event.contentId | toEventContent | async)?.participationLimit"
                class="events__list__item__detail__attendees"
                [total]="(event.contentId | toEventContent | async)?.participationLimit"
                [free]="event.id | getAvailablePlaces | async"
              ></app-event-availability>
            </div>

            <ion-button
              *ngIf="event | canShowJoinButton:(event | eventResponse | async); else changeResponse"
              class="events__list__item__join"
              [innerHTML]="'EVENT_DETAIL_COMPONENT.WEBINAR' | translate"
              (click)="joinEvent(event, $event)"
            ></ion-button>
            <ng-template #changeResponse>
              <app-color-select
                *ngIf="(event?.contentId | toEventContent | async)?.type !== checkUpType; else rescheduleButton"
                class="events__list__item__select"
                [event]="event"
                [availablePlaces]="event?.id | getAvailablePlaces | async"
                [presentingElement]="presentingElement"
                [capacity]="(event?.contentId | toEventContent | async)?.participationLimit"
              ></app-color-select>
            </ng-template>
            <ng-template #rescheduleButton>
              <app-reschedule-button class="events__list__item__reschedule" (clicked)="rescheduleCheckUp(event)"></app-reschedule-button>
            </ng-template>
          </div>
        </ion-item>
      </ng-container>
    </ion-list>

    <ion-infinite-scroll [disabled]="(totalPages$ | async) <= (currentPage$ | async)" (ionInfinite)="loadMoreEvents($any($event))">
      <ion-infinite-scroll-content color="primary" loadingText="Laden..."></ion-infinite-scroll-content>
    </ion-infinite-scroll>
  </div>
</ion-content>
